<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [],
  components: {PageLoader},
  data() {
    return {
      isModalShown: true
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
  },
  created() {
    this.isWufooLoading = true;
  },
};
</script>


// WEBPACK FOOTER //
// PortalForm.vue?4eeee562